import { useQuery } from "@tanstack/react-query";
import type { PlatformHealth } from "@shared/types/health";

/**
 * The aggregated platform health view (FR-71).
 *
 * One authenticated route rather than the two unauthenticated probes the canvas
 * names: `/api/health/queue` and `/api/health/scan` answer AGGREGATES with no
 * tenant or instance in them, because the container platform is not an
 * authenticated caller, so a screen built on them could not show the per
 * instance table this one does. `/api/v2/platform/health` is the same two
 * probes plus the instance breakdown, behind `platform.settings.manage`.
 *
 * Re-read every thirty seconds while the tab is open. Health is the one screen
 * where a stale number is worse than a request: a queue depth from five minutes
 * ago reads exactly like a healthy queue.
 */
export const PLATFORM_HEALTH_PATH = "/api/v2/platform/health";

export const PLATFORM_HEALTH_QUERY_KEY = [PLATFORM_HEALTH_PATH] as const;

export const HEALTH_POLL_INTERVAL_MS = 30_000;

export function usePlatformHealth(enabled = true) {
  return useQuery<PlatformHealth>({
    queryKey: PLATFORM_HEALTH_QUERY_KEY,
    enabled,
    refetchInterval: HEALTH_POLL_INTERVAL_MS,
    staleTime: 0,
  });
}
